import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomersType } from '@cargos/sprintpay-models';
import { AuthGuard, CustomerTypeGuard } from 'src/app/shared/guards/index';
import { FacilityInformationComponent } from './pages';
import { LoginComponent } from './pages/auth/login/login.component';

const routes: Routes = [
    {
        path: 'search-awb',
        loadChildren: () => import('./pages/search-awb/search.module').then((m) => m.SearchModule),
    },
    {
        path: 'cart',
        loadChildren: () => import('./pages/cart/cart.module').then((m) => m.CartDHLModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'cart/payment-method',
        loadChildren: () =>
            import('../../shared/modules/credit-card-guest/guest-payment-method.module').then(
                (m) => m.GuestPaymentMethodModule
            ),
        data: {
            expectedCustomerTypes: [CustomersType.GUEST],
        },
        canActivate: [CustomerTypeGuard, AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'cart/confirmation',
        loadChildren: () => import('./pages/confirmation/confirmation.module').then((m) => m.ConfirmationDHLModule),
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            expectedCustomerTypes: [CustomersType.GUEST],
            hideTitle: true,
        },
        canActivate: [CustomerTypeGuard],
        runGuardsAndResolvers: 'always',
    },
    {
        path: 'facility-information',
        component: FacilityInformationComponent,
    },
    {
        path: 'recover-password',
        loadChildren: () =>
            import('./pages/auth/recover-password/recover-password.module').then((m) => m.RecoverPasswordDHLModule),
    },
    {
        path: 'reset-password',
        loadChildren: () =>
            import('./pages/auth/reset-password/reset-password.module').then((m) => m.ResetPasswordDHLModule),
    },
    {
        path: '**',
        redirectTo: 'search-awb',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'top',
        }),
    ],
    exports: [RouterModule],
})
export class DHLRoutingModule {}
